export default {"src":"/_next/static/media/user.e2fcac9d.svg","height":22,"width":21};